// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"collapse__toggleButton___3MsLD","panel":"collapse__panel___Pthhm"};